import React, { useContext } from 'react';
import { LiveScoreContext } from '@contexts/LiveScoreContext';

const SelectLeague = () => {
    const [ state, dispatch ] = useContext(LiveScoreContext);
    return (
        <div className="modal modal--select-league" data-open={state.openSelectLeaugePopup}>
            <div className="modal__dialog">
                <div className="modal__close" onClick={() => dispatch({ type: 'SHOWSELECTLEAGUEPOPUP' })}>
                    <a className="btn btn--icon">
                        <i className="icon icon--close" />
                    </a>
                </div>
                <div className="modal__header">
                    <a className="btn btn--icon">
                        <i className="icon icon--arrow-left" />
                    </a>
                    <span className="text">Select Leagues</span>
                </div>
                <div className="modal__body">
                    <div className="select-league">
                        <div className="select-league__tab">

                            <div className="tabs tabs--underline">
                                <div className="tabs__content">

                                    <div className="tab" data-selected="true">
                                        <a className="btn">
                                            <span className="text">All</span>
                                            <span className="text text--small">(522)</span>
                                        </a>
                                    </div>

                                    <div className="tab" data-selected="false">
                                        <a className="btn">
                                            <span className="text">Major</span>
                                            <span className="text text--small">(0)</span>
                                        </a>
                                    </div>

                                    <div className="tab" data-selected="false">
                                        <a className="btn">
                                            <span className="text">Minor</span>
                                            <span className="text text--small">(177)</span>
                                        </a>
                                    </div>

                                    <div className="tab" data-selected="false">
                                        <a className="btn">
                                            <span className="text">Others</span>
                                            <span className="text text--small">(345)</span>
                                        </a>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="select-league__scorller">
                            <div className="select-league__list">
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">1. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">2. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">3. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">4. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">5. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">6. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">7. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">8. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">9. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">10. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">11. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">12. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">13. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">14. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">15. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">16. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">17. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">18. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">19. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">20. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">21. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">22. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">23. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">24. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">25. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">26. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">27. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">28. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">29. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                                <div className="select-league__item" data-selected="false">
                                    <span className="text">30. HNL</span>
                                    <i className="icon icon--done" />
                                </div>
                            </div>
                        </div>
                        <div className="select-league__option">
                            <label className="checkbox">
                                <input type="checkbox" />
                                <i className="icon icon--checkbox" />
                                <span className="text">Check All</span>
                            </label>
                            <label className="checkbox">
                                <input type="checkbox" />
                                <i className="icon icon--checkbox" />
                                <span className="text">UnCheck</span>
                            </label>
                            <a className="btn btn--secondary">
                                <span className="text">Go</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default SelectLeague;
